Controller = App.loadClass 'core::Angular/Controller'
DeleteDialog = App.loadClass 'core::DeleteDialog'
Storage = App.loadClass 'core::Storage'

class exports.ViewController extends Controller
    constructor: (
        @state
        @scope
        @transitions
        @data
        @window
        @legacyHandler
        @modal
        @currentLayer
        @loader
        @downloadHandler
        @stateParams
        @q
        @ngModal
        @http
    ) ->
        super(@scope, @transitions)

        # Layers that are handled by Angular 2+
        @angularLayers = ['cover_crop', 'fertilizer', 'spraying']

        @scope.ngModalLauncherOptions = { resolve: {}, ngbModalOptions: { size: 'lg', windowClass: 'extra-wide-form' } }
        # Event Listeners
        @scope.event = 'rendered'

        @scope.appendToEl = angular.element('#bs2-container')

        # This handles cleaning up active layers when leaving the Data page
        @scope.$on '$destroy', () =>
            @loader.hideAll()
            if @state.is('data.add')
                @destroyAllActiveLayers()
            else
                # Clean up everything
                App.layer_store.empty()
                @legacyHandler.destroyAllSubHandlers()
                @legacyHandler.legend.cleanup()

        # This handles the issue of a user selecting a year in
        # the Add tab that they don't have data for, then returning
        # to the view tab. (defaults to the latest year)
        @scope.$watch 'all_years', () =>
            if @scope.all_years? and @scope.selected_options.year?
                if @scope.selected_options.year? and @scope.selected_options.year not in @scope.all_years
                    @scope.selected_options.year = @scope.all_years[0]

        # This is broadcasted from the legacyHandler service and lets
        # us know when something has changed within a layer.
        # (basically, trigger a refresh)
        @scope.$on 'layer:updated', (event, attrs) =>
            @layerUpdated(event, attrs)

        @scope.$on 'legacyDialog:closed', (event, attrs) =>
            @destroyActiveLayer attrs.layer

        @scope.$on 'legend:update-rows', () =>
            # update the view using information from a new layer
            @scope.legend_rows = @legacyHandler.legend.constructRows()
            @scope.$apply()

        @scope.$on 'legend:stack-ready', () =>
            if @legacyHandler.legend.comparePreviousStackValues(@scope.legend_rows)
                # update the legend on the front end using the current rows
                @legacyHandler.legend.updateLegend()
            else
                # update legend rows and refresh the view
                @scope.legend_rows = @legacyHandler.legend.getPreviousStack()

        @scope.$on 'rendered', () =>
            # update the legend on the front end
            @legacyHandler.legend.updateLegend()
            @scope.$apply()

        ### Deep watch selected_options ###
        @scope.$watch 'selected_options', () =>
            # ensure both filters have valid selected options before attempting to fetch data
            if @scope.selected_options?.field and @scope.selected_options?.year
                @legacyHandler.destroyAllSubHandlers()
                @getTableData(@scope.selected_options.year, @scope.selected_options.field.field_id)
                @scope.ngModalLauncherOptions.resolve.fieldId = @scope.selected_options.field.field_id
                @scope.ngModalLauncherOptions.resolve.year = @scope.selected_options.year
        , true

        # This is broadcasted from the mfDataViewHeight directive and lets
        # us know that resizing is complete
        @scope.$on 'data-view:resized', () =>
            @loader.hideAll()

        # This integrates SAFElink functionality
        @scope.$on 'app:safelinked', () =>
            # Reset everything if safelinked to a new person
            @scope.active = false
            @scope.$parent.selected_options.field = null
            @scope.selected_options.field = null
            @loadScopeData @data.getAllYears(), 'all_years'
            @loadScopeData @data.getSidebarFields(), 'fields'
            @loadScopeData @data.getUserType(), 'is_owner'
            @scope.formsData = []
            @scope.mapsData = []


        # Variable Declarations
        @scope.selected_options = @scope.$parent.selected_options
        @scope.tableData = null

        @scope.formsData = []
        @scope.mapsData = []
        @scope.bulkDeleteArray = []
        @scope.activeLayers = []
        @scope.legend_rows = []

        @scope.active = true
        @scope.view = true
        @scope.startEdit = false
        @scope.bulkDeleting = false     #used to manage bulk delete state
        @scope.useSlider = true
        @scope.showDelete = false
        @scope.styling_finished = false
        # TODO: maybe these shouldn't be in the controller?
        @scope.form_table_style = height: 0
        @scope.map_table_style = height: 0
        @scope.new_dropdown_style = position: '', top: 0, left: 0, width: 0

        # Function Declarations
        @scope.getTableData = @getTableData
        @scope.handleRowClick = @handleRowClick
        @scope.editLayer = @editLayer
        @scope.editManagementZoneLayer = @editManagementZoneLayer
        @scope.editRxLayer = @editRxLayer
        @scope.deleteLayer = @deleteLayer
        @scope.startBulkDelete = @startBulkDelete
        @scope.launchBulkDeleteDialog = @launchBulkDeleteDialog
        @scope.endBulkDelete = @endBulkDelete
        @scope.downloadFile = @downloadHandler.downloadFile
        @scope.handleTableHeight = @handleTableHeight
        @scope.update_dropdown_styling = @update_dropdown_styling # what is this??
        @scope.irrigationDetails = @irrigationDetails
        @scope.isAngularLayer = @isAngularLayer
        @scope.getComponentByLayer = @getComponentByLayer
        @scope.getModalOptionsByLayer = @getModalOptionsByLayer
        @scope.downgradedDialogClosed = @downgradedDialogClosed
        @scope.downgradedDialogSaved = @downgradedDialogSaved
        @scope.getLayerCountByType = @getLayerCountByType
        @scope.getLayerTitle = @getLayerTitle

        # Retrieve data from DataSidebarService (@data)
        promises = [
            @loadScopeData @data.getSidebarFields(), 'fields'
            @loadScopeData @data.getUserType(), 'is_owner'
        ]

        # Auto set the field
        @q.all(promises).then () =>
            if @stateParams.field
                for field in @scope.fields
                    if parseInt(field.field_id) is parseInt(@stateParams.field)
                        @scope.selected_options.field = field
                        break

            if @stateParams.year
                @scope.selected_options.year = @stateParams.year

    downgradedDialogClosed: (result) =>
        # deselect selected angular layers
        for layer in @scope.activeLayers when @isAngularLayer(layer)
            @destroyActiveLayer(layer)

    downgradedDialogSaved: (result) =>
        # deselect selected angular layers and reload the sidebar
        @layerUpdated()

    showLoader: () =>
        msg = @loader.overSidebar 'Loading...'

    update_dropdown_styling: () =>
        # Ensures that the cog button dropdown is properly styled before it is displayed
        @scope.styling_finished = true
        @scope.$digest()


    loadScopeData: (promise, key) =>
        # Resolve the promise and then load the
        # given by key data into the scope variable
        promise.then (response) =>
            if response?.data?.status?.type is 'success'
                @scope[key] = response.data.data
        return promise


    getTableData: (year, field_id) =>
        return if not field_id

        # Reset bulk delete button
        @scope.showDelete = false
        @scope.tableData = null

        @showLoader()
        # fetch data to populate form and map tables
        if field_id? and year?

            # Display new field boundary
            @data.loadFieldBoundary(field_id)

            # Fetch the new field data
            @loadScopeData(@data.getTableData(year, field_id), 'tableData').then (response) =>
                @sortTableData()

    sortTableData: () =>
        # Takes all layers and assigns them to the map or forms table
        @scope.formsData = []
        @scope.mapsData = []
        for layer in @scope.tableData
            if layer.layer_type in ['planting_rx', 'shapefile'] or layer.is_map
                layer.is_map = true # just to ensure this is set
                @scope.mapsData.push(layer)
            else
                layer.is_map = false
                @scope.formsData.push(layer)

        @checkBulkDelete()
        @callResizer()          # resize the tables since we've loaded new data


    getLayerCountByType: (layerType) =>
        return @scope.formsData.filter((layer) =>
            return layer.layer_type is layerType
        ).length

    getMapCountByType: (activeLayer) =>
        return @scope.mapsData.filter((layer) =>
            if layer.category_name
                return layer.category_name is activeLayer.category_name
            return layer.layer_type is activeLayer.layer_type
        ).length

    getLayerTitle: (layer, isMapLayer = true) =>
        if isMapLayer
            return if @getMapCountByType(layer) > 1 then layer.layer_title else layer.orig_title
        return if @getLayerCountByType(layer.layer_type) > 1 then layer.layer_title else layer.orig_title

    # Clean up any open forms
    destroyAllActiveLayers: () =>
        @state.go('grower.data.view')
        for layer in @scope.activeLayers
            # this is how LegacyHandlerService sets the subhandler name
            subHandler = layer.layer_type + layer.layer_id
            @legacyHandler.destroySubHandler(subHandler, true)
            layer.handler = null

        @scope.activeLayers = []

        # Clean up any map related dialogs (shapefile binning)
        @destroyDialog()

    destroyActiveLayer: (layer) =>
        # handling for form layers
        if layer.layer_type is 'planting'
            _.remove @scope.activeLayers, (active_layer) -> active_layer is layer
            @state.go('grower.data.view')
            return

        if @isAngularLayer(layer) and  _.includes(@scope.activeLayers, layer)
            _.remove @scope.activeLayers, (active_layer) -> active_layer is layer
            return true

        # this is how LegacyHandlerService sets the subhandler name
        subHandler = layer.layer_type + layer.layer_id
        index = @scope.activeLayers.indexOf layer

        # return false if the layer doesn't have an active sub handler
        if not @legacyHandler.activeSubHandlers[subHandler] and index is -1
            return false

        # destroy the additional dialogs that may be spawned by the layer
        if layer.layer_type is 'shapefile'
            @destroyDialog(layer.layer_id)

        # destroy the dialog and remove it from the array
        @legacyHandler.destroySubHandler(subHandler, true)

        # remove the layer from the active layers
        _.remove @scope.activeLayers, (active_layer) -> active_layer is layer

        # set the reference to the handler on the layer to null since we're destroying it
        layer.handler = null

        # Force a digest cycle as soon as possible to update the sidebar highlighting.
        # This should be unnecessary, but it just doesn't work.
        # https://www.pivotaltracker.com/story/show/133285591
        setTimeout () =>
            @scope.$apply()
        , 0

        return true


    handleRowClick: (layer, e) =>
        # if we're in 'bulk delete' mode
        if @scope.bulkDeleting
            if layer.can_delete is true
                @toggleBulkDeleteLayer(layer)
            return

        # check if layer already exists in the array
        # this is how LegacyHandlerService sets the subhandler name
        # layerName = layer.layer_type + layer.layer_id
        if @destroyActiveLayer(layer)
            return

        # deselect non legacy layers when their dialog is closed
        destroyLayer = () =>
            # remove transition hook
            layer.release()
            # destroy layer
            @destroyActiveLayer(layer)
        if layer.layer_type is 'planting'
            @scope.activeLayers.push layer
            # deselect row when dialog is closed
            layer.release = @transitions.onFinish { to: 'grower.data.view' }, destroyLayer
            # for form layers that have been angularized
            @viewFormLayer(layer)
        else if layer.layer_type is 'ears_rows_length'
            @ngModal.openERLDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'View', layer.layer_id)
            .modalRef.result.catch _.noop
        else if layer.layer_type is 'harvest_load'
            @http.get("backend/grower/layers/harvest-load/#{layer.layer_id}/load-layer").then (harvestLoad) =>
                @ngModal.openHarvestLoadDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'View', harvestLoad.data)
                .modalRef.result.catch _.noop
        else if layer.layer_type is 'stand_count'
            @http.post 'backend/grower/layers/standcount/load-layer', { id: layer.id }
            .then (standCountLoad) =>
                @ngModal.openStandCountDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'View', standCountLoad.data)
                .modalRef.result
        else if layer.layer_type is 'field_details'
            @scope.activeLayers.push layer
            # deselect row when dialog is closed
            layer.release = @transitions.onFinish { to: 'grower.data.view' }, destroyLayer
            @state.go('grower.data.view.field-details', { id: layer.id, year: @scope.selected_options.year, editing: false })
        else if not @isAngularLayer(layer)
            @viewLegacyLayer(layer)
        else
            @scope.activeLayers.push layer
    irrigationDetails: (layer) =>
        @state.go 'grower.data.view.irrigation-details', { layer_id: layer.id, year: @scope.selected_options.year, field_id: @scope.selected_options.field.field_id }

    isAngularLayer: (layer) =>
        return layer?.layer_type in @angularLayers

    viewFormLayer: (layer, edit = false) =>
        opts = @scope.selected_options
        params =
            id: layer.id
            edit: if edit then 'edit' else null
        if layer.layer_type is 'planting'
            params.is_ingredion_field = (opts.field.external_name? and
                opts.field.external_name is 'Ingredion' and
                opts.field.external_permission)
        @state.go "grower.data.view.#{layer.layer_type}", params

    viewLegacyLayer: (layer) =>
        @scope.activeLayers.push(layer)

        # Create the view dialog via the service
        save_url = @legacyHandler.getLegacyFilePath(layer.layer_type)

        postParams =
            fields_id: layer.fields_id
            has_edit: false
            id: layer.id
            layer_id: layer.layer_id
            year: layer.year
            extra_data: layer.extra_data ? null

        layer.handler = @legacyHandler.createViewDialog(
            layer.layer_type
            save_url
            false
            false
            layer
            postParams
        )

    editLayer: (layer) =>
        # Handle management zone editing
        if layer.layer_type is 'management_zone'
            @editManagementZoneLayer(layer)
        else if layer.layer_type is 'ears_rows_length'
            @ngModal.openERLDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Edit', layer.layer_id)
            .modalRef.result.catch _.noop
        else if layer.layer_type is 'harvest_load'
            @http.get("backend/grower/layers/harvest-load/#{layer.layer_id}/load-layer").then (harvestLoad) =>
                @ngModal.openHarvestLoadDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Edit', harvestLoad.data)
                .modalRef.result.catch _.noop
        else if layer.layer_type is 'stand_count'
            @http.post 'backend/grower/layers/standcount/load-layer', { id: layer.id }
            .then (standCountLoad) =>
                @ngModal.openStandCountDialog(@scope.selected_options.field.field_id, @scope.selected_options.year, 'Edit', standCountLoad.data)
                .modalRef.result.catch _.noop
        else if layer.layer_type is 'planting'
            # for form layers that have been angularized
            @editFormLayer(layer)
        else if layer.layer_type is 'field_details'
            @state.go('grower.data.view.field-details', { id: layer.id, year: @scope.selected_options.year, editing: true })
        else if not @isAngularLayer(layer)
            @editLegacyLayer(layer)

    editFormLayer: (layer) =>
        @viewFormLayer(layer, true)

    editLegacyLayer: (layer) =>
        # Special handling for 'special' things..
        if layer.layer_type is 'shapefile'
            @legacyHandler.getLegacyFilePath('ShapefileBinning')
        else
            @legacyHandler.getLegacyFilePath(layer.layer_type)

        postParams =
            fields_id: layer.fields_id
            has_edit: true
            id: layer.id
            layer_id: layer.layer_id
            year: layer.year
            extra_data: layer.extra_data ? null

        layer.handler = @legacyHandler.createViewDialog(
            layer.orig_title
            null
            false
            true
            layer
            postParams
        )

    editManagementZoneLayer: (layer) =>
        # set year on the layer
        layer.year = @scope.selected_options.year
        layer.handler = null
        # launch editing process
        @state.go 'grower.data-edit-zone', request: JSON.stringify layer

    editRxLayer: (id) =>
        options = new Storage()
        options.store 'from_state', 'grower.data.view'
        window.RxStorage = options
        @state.go 'grower.planting-rx', { id }

    deleteLayer: (layer) =>
        # the second part of the if statement is for irrigation management zones so the user can still click delete on layers that they can't actually delete
        if layer.can_delete and (not layer.can_actually_delete? or layer.can_actually_delete)
            @legacyHandler.createDeleteDialog(layer)
        else if layer.extra_info?.crops?.length
            # irrigation layers have special handling when you try to delete one that shouldn't be deleted
            @launchRestrictedDeleteDialog(layer)

    launchRestrictedDeleteDialog: (layer) =>
        # irrigation layers have special handling when you try to delete one that shouldn't be deleted
        # check extra_info mapping values to determine which text to use in the dialog
        message = 'You may not delete this Irrigation map. It is needed for your '
        has_fieldprint = true in (crop.has_fieldprint for k, crop of layer.extra_info.mappings)
        has_planting_rx = true in (crop.has_planting_rx for k, crop of layer.extra_info.mappings)

        if has_fieldprint and has_planting_rx
            message += "Fieldprint Analysis and Rx Plan."
        else if has_fieldprint
            message += "Fieldprint Analysis."
        else if has_planting_rx
            message += "Rx Plan."

        newscope = @scope.$new()
        newscope.title = 'Delete - Irrigation Zone Layer'
        newscope.body = message
        newscope.yesText = 'Ok'
        newscope.noText = 'Close'

        dlg = @modal.open
            windowClass: 'sm_dialog'
            templateUrl: 'backend/core/confirm-dialog'
            controller: 'ConfirmDialogController'
            scope: newscope

    callResizer: () =>
        # trigger the mfResizable directive
        angular.element(@window).trigger('resize')


    checkBulkDelete: () =>
        for layer in _.concat(@scope.formsData, @scope.mapsData)
            if layer.can_delete is true
                @scope.showBulkDelete = true
                return

    startBulkDelete: () =>
        @destroyAllActiveLayers()
        # @scope.activeLayers = []
        # for layer in @scope.mapsData
        #     layer.handler = null
        # @legacyHandler.destroyAllSubHandlers()

        @scope.bulkDeleting = true

    toggleBulkDeleteLayer: (layer) =>

        # dont allow irrigation layers that shouldn't be deleted to be selected for bulk deletion
        if layer.can_actually_delete? and not layer.can_actually_delete and layer.extra_info?.crops?.length
            # launch dialog to inform the user why the layer cannot be deleted
            @launchRestrictedDeleteDialog(layer)
            return

        if layer in @scope.bulkDeleteArray
            _.remove @scope.bulkDeleteArray, (del_layer) => del_layer is layer
        else
            @scope.bulkDeleteArray.push(layer)

    launchBulkDeleteDialog: () =>
        dialog = @modal.open
            windowClass: 'sm_dialog'
            templateUrl: 'backend/grower/data/ng-bulk-delete'
            controller: 'Data.Controllers.BulkDeleteController'
            resolve:
                'DeleteArray': () => @scope.bulkDeleteArray

        dialog.result.then (response) =>
            @endBulkDelete(true)

    getCountByLayerType: (type) =>
        return @scope.formData.filter((layer) =>
            return layer.layer_type is type
        ).length

    endBulkDelete: (reload_data = false) =>
        # Clear everything out and refresh the view
        @scope.bulkDeleteArray = []
        @scope.bulkDeleting = false

        if reload_data
            @getTableData(@scope.selected_options.year, @scope.selected_options.field?.field_id)


    # Destroy any additional dialogs (e.g. shapefile has a binning dialog)
    destroyDialog: (layerId) =>
        # layer types that can have additional dialogs
        layer_types = ['File Conversion']

        for name, subHandler of @legacyHandler.activeSubHandlers
            # ignore the delete dialog
            # (this can go away if we convert the delete dialog to angular)
            if subHandler instanceof DeleteDialog
                break

            ###
                Handle deleting the shapefile binning dialogs that are
                associated with layers that are being deselected

                The naming convention for these dialogs is
                "File Conversion"+id_of_related_layer
            ###

            # only delete dialogs that are of the allowed type and belong to an active layer that is being deselected
            for type in layer_types when name.indexOf(type) isnt -1 and name.indexOf(layerId) isnt -1
                subHandler.destroy()
                break

    layerUpdated: (event, attributes) =>
        @showLoader()

        if attributes?.layer?
            @destroyActiveLayer(attributes.layer)

        @loadScopeData(@data.getSidebarFields(), 'fields').then () =>
            # Update the field name in the select dropdown if it changed.
            if @scope.selected_options.field?
                for field in @scope.fields
                    if field.field_id is @scope.selected_options.field.field_id
                        @scope.selected_options.field = field
                        break

            @getTableData @scope.selected_options.year, @scope.selected_options.field?.field_id
